import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import NavbarPrimary from "./NavbarPrimary";
import NavbarSecondary from "./NavbarSecondary";
import Frame11322 from "../Frame11322";
import "./Header.css";

const icamLogo =
  "https://upload.wikimedia.org/wikipedia/commons/3/3f/ICAM_logo.png";

/**
 * Composant Header unifié pour l'ensemble du site
 */
const Header = ({
  primaryItems = [],
  secondaryItems = [],
  showSecondary = false,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false); // ✅ pour replier/déplier le header
  const location = useLocation();

  // ✅ Gestion responsive
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Fermer le menu mobile au changement de page
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // ✅ Toggle menu mobile
  const toggleMenu = () => setMenuOpen(!menuOpen);

  // ✅ Toggle header plié/déplié
  const toggleHeader = () => setCollapsed(!collapsed);

  return (
    <>
      {/* === HEADER PRINCIPAL === */}
      <header className={`app-header ${collapsed ? "collapsed" : ""}`}>
        <div className="header-container">
          {/* ✅ Logo ICAM */}
          <div className="header-logo-container">
            <Link to="/home" className="header-logo-link">
              <img src={icamLogo} alt="ICAM Logo" className="header-logo" />
            </Link>
          </div>

          {/* ✅ Navigation principale */}
          {isMobile ? (
            <>
              <button
                className={`mobile-menu-button ${menuOpen ? "active" : ""}`}
                onClick={toggleMenu}
                aria-label="Menu principal"
                aria-expanded={menuOpen}
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>

              <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
                <NavbarPrimary items={primaryItems} isMobile={true} />
                {showSecondary && (
                  <NavbarSecondary items={secondaryItems} isMobile={true} />
                )}
                <Frame11322 className="logout-button-mobile" />
              </div>
            </>
          ) : (
            <div className="navigation-container">
              <NavbarPrimary items={primaryItems} />
              {showSecondary && <NavbarSecondary items={secondaryItems} />}
              <Frame11322 className="logout-button" />
            </div>
          )}
        </div>
      </header>

      {/* === Bouton de repli/dépli fixe === */}
      <button
        className={`toggle-header-button ${collapsed ? "collapsed" : ""}`}
        onClick={toggleHeader}
        title={collapsed ? "Afficher le header" : "Masquer le header"}
      >
        {collapsed ? "▼" : "▲"}
      </button>
    </>
  );
};

export default Header;
